var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mt-6 shop-options"
  }, [_c('v-card-title', [_c('v-row', [_c('v-col', {
    staticClass: "subtitle-1 py-0"
  }, [_vm._v("옵션사용 (사용/미사용)")]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.input
    },
    model: {
      value: _vm.optionsEnabled,
      callback: function ($$v) {
        _vm.optionsEnabled = $$v;
      },
      expression: "optionsEnabled"
    }
  })], 1)], 1)], 1), _vm.optionsEnabled ? _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_vm._v("옵션명 개수")]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.optionsCountHeaders,
      "item-text": "text",
      "item-value": "value",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.input
    },
    model: {
      value: _vm.optionsCount,
      callback: function ($$v) {
        _vm.optionsCount = $$v;
      },
      expression: "optionsCount"
    }
  })], 1)], 1), _c('v-divider', {
    staticClass: "mt-4"
  }), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_vm._v("정렬순서")]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.optionsSortHeaders,
      "item-text": "text",
      "item-value": "value",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.input
    },
    model: {
      value: _vm.optionsSort,
      callback: function ($$v) {
        _vm.optionsSort = $$v;
      },
      expression: "optionsSort"
    }
  })], 1)], 1), _c('v-divider', {
    staticClass: "mt-4"
  }), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_vm._v("옵션입력")]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_vm._v("옵션명")]), _c('v-col', {
    staticClass: "py-0"
  }, [_vm._v("옵션값")]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "2"
    }
  })], 1), _vm._l(_vm.optionsCount, function (i, index) {
    return _c('v-row', {
      key: index,
      staticClass: "mt-2"
    }, [_c('v-col', {
      staticClass: "py-0"
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "placeholder": _vm.placeholders[index].name
      },
      model: {
        value: _vm.optionsGroups[index].name,
        callback: function ($$v) {
          _vm.$set(_vm.optionsGroups[index], "name", $$v);
        },
        expression: "optionsGroups[index].name"
      }
    })], 1), _c('v-col', {
      staticClass: "py-0"
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "placeholder": _vm.placeholders[index].value
      },
      model: {
        value: _vm.optionsGroups[index].value,
        callback: function ($$v) {
          _vm.$set(_vm.optionsGroups[index], "value", $$v);
        },
        expression: "optionsGroups[index].value"
      }
    })], 1), _c('v-col', {
      staticClass: "py-0",
      attrs: {
        "cols": "2"
      }
    }, [1 < _vm.optionsCount ? _c('v-btn', {
      staticClass: "px-1 mr-1 primary--text",
      staticStyle: {
        "min-width": "auto"
      },
      attrs: {
        "color": "white",
        "small": ""
      },
      on: {
        "click": function ($event) {
          _vm.optionsCount--;
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-minus")])], 1) : _vm._e(), i == _vm.optionsCount && i < _vm.optionsCountHeaders.length ? _c('v-btn', {
      staticClass: "px-1",
      staticStyle: {
        "min-width": "auto"
      },
      attrs: {
        "color": "primary",
        "small": ""
      },
      on: {
        "click": function ($event) {
          _vm.optionsCount++;
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-plus")])], 1) : _vm._e()], 1)], 1);
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.generate();
        _vm.input();
      }
    }
  }, [_vm._v("옵션목록으로 적용"), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-down")])], 1)], 1), _c('v-spacer')], 1)], 2)], 1), _c('v-divider', {
    staticClass: "mt-4"
  }), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_vm._v("옵션목록")]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('v-row', [_c('v-spacer'), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "2",
      "md": "1"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.operatorItems,
      "label": "연산자",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.header.operator,
      callback: function ($$v) {
        _vm.$set(_vm.header, "operator", $$v);
      },
      expression: "header.operator"
    }
  })], 1), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "옵션가",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        _vm.header.price = _vm.header.price.replace(/[^0-9]/, '');
      }
    },
    model: {
      value: _vm.header.price,
      callback: function ($$v) {
        _vm.$set(_vm.header, "price", $$v);
      },
      expression: "header.price"
    }
  })], 1), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "재고수량",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        _vm.header.stock = _vm.header.stock.replace(/[^0-9]/, '');
      }
    },
    model: {
      value: _vm.header.stock,
      callback: function ($$v) {
        _vm.$set(_vm.header, "stock", $$v);
      },
      expression: "header.stock"
    }
  })], 1), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "2",
      "md": "1"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.enabledItems,
      "label": "사용여부",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.header.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.header, "enabled", $$v);
      },
      expression: "header.enabled"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": _vm.modify
    }
  }, [_vm._v("선택목록 일괄수정")])], 1)], 1), _c('v-data-table', {
    attrs: {
      "headers": _vm.optionsHeaders,
      "items": _vm.options.filter(function (option) {
        return !option.deleted;
      }),
      "item-key": "name",
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: `header.value`,
      fn: function (_ref) {
        var header = _ref.header;
        return [_c('v-row', [_c('v-col', [_vm._v("옵션명")])], 1), _vm.options[0] ? _c('v-divider') : _vm._e(), _vm.options[0] ? _c('v-row', _vm._l(_vm.options[0].name.split('/'), function (name, index) {
          return _c('v-col', {
            key: index
          }, [_vm._v(_vm._s(name.split(":")[0]))]);
        }), 1) : _vm._e()];
      }
    }, {
      key: `item.value`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-row', _vm._l(item.value.split('/'), function (value, index) {
          return _c('v-col', {
            key: index,
            staticClass: "pa-0"
          }, [_vm._v(_vm._s(value))]);
        }), 1)];
      }
    }, {
      key: `item.price`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('v-text-field', {
          staticClass: "price",
          attrs: {
            "dense": "",
            "hide-details": ""
          },
          on: {
            "input": _vm.input
          },
          model: {
            value: item.price,
            callback: function ($$v) {
              _vm.$set(item, "price", $$v);
            },
            expression: "item.price"
          }
        })];
      }
    }, {
      key: `item.stock`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('v-text-field', {
          staticClass: "price",
          attrs: {
            "dense": "",
            "hide-details": ""
          },
          on: {
            "input": _vm.input
          },
          model: {
            value: item.stock,
            callback: function ($$v) {
              _vm.$set(item, "stock", $$v);
            },
            expression: "item.stock"
          }
        })];
      }
    }, {
      key: `item.enabled`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('v-simple-checkbox', {
          attrs: {
            "dense": "",
            "color": "primary"
          },
          on: {
            "input": _vm.input
          },
          model: {
            value: item.enabled,
            callback: function ($$v) {
              _vm.$set(item, "enabled", $$v);
            },
            expression: "item.enabled"
          }
        })];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref6) {
        var item = _ref6.item,
          index = _ref6.index;
        return [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.remove(item, index);
            }
          }
        }, [_vm._v("mdi-delete")])];
      }
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }